/* eslint-disable import/no-extraneous-dependencies */
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
// eslint-disable-next-line import/no-extraneous-dependencies
import { withRouter } from 'react-router-dom';
import * as deviceSetupActions from '../../actions';
import injectReducer from '../../../../utils/injectReducer';
import injectSaga from '../../../../utils/injectSaga';
import saga from '../../sagas';
import taggingSaga from '../../../Common/Tagging.js/sagas';
import cartSaga from '../../../../services/Cart/sagas';
import * as cartActions from '../../../../services/Cart/actions';
import * as taggingActions from '../../../Common/Tagging.js/actions';
import deviceSetup from '../../reducer';
import { getPlansData } from '../../../../utils/plansReference';
import DeviceSetup from '../../../../components/Web/DeviceSetup/redesign/index';

const mapStateToProps = (state) => {
  const homePlanState = state.homePlans ? state.homePlans : state.deviceSetup;
  const selectedOption = state.deviceSetup.saveSelectedOption;
  const cartDetails = state.cartDetails ? state.cartDetails : {};
  // const plansReferenceData = checkPlanReferenceData(state.plansReferenceData);

  const plansReferenceData = getPlansData(state.plansReferenceData);
  const setupError = state.deviceSetup.showError;
  const deviceSetupServiceInfo = state?.deviceSetup?.deviceSetupService;
  const deviceSetUpState = state?.deviceSetup || {};
  const eligible5GHomeBundle = state.cartDetails?.cartDetailsJson?.orderDetailsView?.eligible5GHomeBundle || [];
  const setupInvalidError = state?.deviceSetup?.setupInvalidError;
  const currentView = state.currentView || {};
  const deviceSetupError = state?.deviceSetup?.deviceSetupError;
  const setupShowError = state?.deviceSetup?.setupShowError || false;
  const setupNtfyMsg = state?.deviceSetup?.setupNtfyMsg || null;
  const apiLoaded = state.SessionValues?.apiLoaded;
  const channelSession = state.tagging?.channelSession;
  const updateSetupProcessStep = state.deviceSetup?.updateSetupProcessStep;
  const nextProcessStep = state.Redirection?.nextProcessStep;
  const { appointmentScheduleResponse } = state.appointmentSchedule;
  const appointmentScheduleState = state.appointmentSchedule || {};

  return {
    selectedOption,
    cartDetails,
    homePlanState,
    plansReferenceData,
    setupError,
    deviceSetupServiceInfo,
    deviceSetUpState,
    eligible5GHomeBundle,
    selectedSetup: deviceSetUpState && deviceSetUpState.selectedOption,
    setupInvalidError,
    currentView,
    deviceSetupError,
    setupShowError,
    setupNtfyMsg,
    apiLoaded,
    channelSession: channelSession || null,
    updateSetupProcessStep,
    nextProcessStep,
    appointmentScheduleResponse,
    appointmentScheduleState,
  };
};
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...deviceSetupActions,
      ...cartActions,
      ...taggingActions,
    },
    dispatch,
  );
}
const withReducer = compose(injectReducer({ key: 'deviceSetup', reducer: deviceSetup }));

const withConnect = connect(mapStateToProps, mapDispatchToProps);
const withSaga = compose(
  injectSaga({ key: 'deviceSetup', saga }),
  injectSaga({ key: 'cartDetails', saga: cartSaga }),
  injectSaga({ key: 'taggingDetails', saga: taggingSaga }),
);

export default withRouter(compose(withSaga, withReducer, withConnect)(DeviceSetup));
